import { combineReducers } from "@reduxjs/toolkit";

import initReducer from "./slices/init/init.slice";
import popupReducer from "./slices/popup/popup.slice";
import addReportReducer from "./slices/addReport/popup.slice";
import yourReportsReducer from "./slices/addReport/yourReports.slice";
import productYourReportsReducer from "./slices/addReport/productYourReport.slice";
import addReportReducerDutyFree from "./slices/addReportDutyFree/popup.slice";
import yourReportsReducerDutyFree from "./slices/addReportDutyFree/yourReports.slice";
import productYourReportsReducerDutyFree from "./slices/addReportDutyFree/productYourReport.slice";
import toggleDropdownReducer from "./slices/dropdown/toggle.slice";
import dashboardReducer from "./slices/Products/dashboard.slice";
import productReducer from "./slices/Products/product.slice";
import livePriceChangeReducer from "./slices/Products/livePriceChange.slice";
import constantReducer from "./slices/constants/constant.slice";
import watchlistReducer from "./slices/watchlist/data.slice";
import priceHistoryReducer from "./slices/Products/priceHistory.slice";
import analyticsReducer from "./slices/analytics/analytics.slice";
import fnbDashboardReducer from "./slices/fnb/dashboard.slice";
import fnbProductsReducer from "./slices/fnb/products.slice";
import fnbConstantsReducer from "./slices/fnb/constants.slice";
import fnbPriceHistoryReducer from "./slices/fnb/priceHistory.slice";
import fnbPriceChangesReducer from "./slices/fnb/priceChanges.slice";
import aiReducer from "./slices/ai/ai.slice";
import userReducer from "./slices/user/user.slice";


const rootReducer = combineReducers({
  init: initReducer,
  popup: popupReducer,
  addReport: addReportReducer,
  yourReports: yourReportsReducer,
  productYourReports: productYourReportsReducer,
  addReportDutyFree: addReportReducerDutyFree,
  yourReportsDutyFree: yourReportsReducerDutyFree,
  productYourReportsDutyFree: productYourReportsReducerDutyFree,
  toggleDropdown: toggleDropdownReducer,
  dashboard: dashboardReducer,
  products: productReducer,
  livePrice: livePriceChangeReducer,
  constant: constantReducer,
  watchlist: watchlistReducer,
  priceHistory: priceHistoryReducer,
  analytics: analyticsReducer,
  fnbDashboard: fnbDashboardReducer,
  fnbProducts: fnbProductsReducer,
  fnbConstants: fnbConstantsReducer,
  fnbPriceHistory: fnbPriceHistoryReducer,
  fnbPriceChanges: fnbPriceChangesReducer,
  ai: aiReducer,
  user: userReducer
});

export default rootReducer;
